<template>
    <sidebar @close="$emit('close')">
        <template v-slot:title>
            Tax Reciprocal Agreement
        </template>

        <slot>
            <div class="card mb-2">
                <div class="card-header pr-1 d-flex align-items-center">
                    <span class="btnlike mr-auto">
                        <h4 class="mb-0">Details</h4>
                    </span>

                    <button v-if="agreement.is_active" class="btn btn-outline-danger ml-1" type="button" @click.prevent="onDeactivate">Deactivate</button>
                </div>

                <div class="card-body py-1">
                    <section class="item-details-section">
                        <div>
                            <span class="text-semibold">Work Location Tax: </span>
                            <span>{{ agreement.work_location_tax ? agreement.work_location_tax.description : '—' }}</span>
                        </div>

                        <div>
                            <span class="text-semibold">Resident Location Tax: </span>
                            <span>{{ agreement.resident_location_tax ? agreement.resident_location_tax.description : '—' }}</span>
                        </div>

                        <div>
                            <span class="text-semibold">Created: </span>
                            <span>{{ agreement.created_on ? $filters.datetime(agreement.created_on) : '—' }}</span>
                        </div>
                    </section>
                </div>
            </div>
        </slot>
    </sidebar>
</template>

<script>
import Sidebar from '@/components/Sidebar'

export default {
    components: {Sidebar},
    props: ['agreement'],
    emits: ['close', 'deactivated'],
    methods: {
        onDeactivate() {
            if (!confirm('Are you sure you want to deactivate this tax reciprocal agreement?')) { return }

            this.$store.dispatch('START_LOADING')
            this.$api.del(`/admin/tax-engine/tax-reciprocal-agreements/${this.agreement.id}`).then(() => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('deactivated')
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(errors.__all__)
            })
        },
    },
}
</script>
